import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Openwin } from '../entity/Openwin-angular';


@Injectable({
  providedIn: 'root'
})
export class OpenwinServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Openwin();
    this.entityType.type = EntityType.master;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MainTable: '主資料表', ITEM: '序號', TYPE: '類別', CreateDate: '建立日期', ModiDate: '修改日期', Title: '標題', SQLSelect: 'SQLSelect', SQLWhere: 'SQLWhere', PS: '備註', Display: '顯示', MAP: 'MAP', CreateUserID: '建檔者', SQLOrder: '欄位排序', SQLReturn: 'SQLReturn'
    };

    this.fieldNames = 'MainTable,ITEM,TYPE,CreateDate,ModiDate,Title,SQLSelect,SQLWhere,PS,Display,MAP,CreateUserID,SQLOrder,SQLReturn';
    this.fieldLengths = { MainTable: 50, ITEM: 50, TYPE: 1, CreateDate: 0, ModiDate: 0, Title: 50, SQLSelect: 0, SQLWhere: 0, PS: 255, Display: 0, MAP: 0, CreateUserID: 50, SQLOrder: 0, SQLReturn: 0 };
    this.columnDefs = [
      { field: "Title", headerName: "標題", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "PS", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MainTable", headerName: "主資料表", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "ITEM", headerName: "序號", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "TYPE", headerName: "類別", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "Display", headerName: "顯示", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SQLOrder", headerName: "欄位排序", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "CreateDate", headerName: "建立日期", headerTooltip: "", width: 120, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "ModiDate", headerName: "修改日期", headerTooltip: "", width: 120, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "SQLSelect", headerName: "SQLSelect", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SQLWhere", headerName: "SQLWhere", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MAP", headerName: "MAP", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SQLReturn", headerName: "SQLReturn", headerTooltip: "", width: 250, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'OpenWin';
    this.isSys = true;
    this.sqlSelect = `SELECT OpenWin.*  FROM ##OpenWin`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MainTable,ITEM,TYPE`;
    this.keyFields = ['MainTable', 'ITEM', 'TYPE'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MainTable', 'ITEM', 'TYPE', 'SQLSelect', 'SQLWhere', 'Display', 'MAP'];
    this.seqField = 'ITEM';
    this.seqFieldLength = 50;
  }
  override async validateItem(item: Openwin): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Openwin): Promise<Openwin> {
    await super.newRecord(newItem);
    return newItem;
  }




}

